import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import {
  AvailableLanguages,
  Language,
  LOCALSTORAGE_DEFAULT_UI_LANGUAGE_KEY,
  LOCALSTORAGE_USER_UI_LANGUAGE_KEY,
} from '@pt/pt-models';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class SwitchLanguageService {
  selectedLanguage: string = SwitchLanguageService.getDefaultLanguage();

  //todo @georgy temporal use to enable en language to system
  // togo @giovanni l'ho rimosso generava dipendenza circolare
  // private _loginResponse$ = toSignal(this.store.select(PtCoreSelectors.loginResponse), {requireSync: true});

  constructor(private store: Store, private translate: TranslateService) {}

  static getDefaultLanguage() {
    return LOCALSTORAGE_DEFAULT_UI_LANGUAGE_KEY;
    //
    // const userLang = localStorage.getItem(LOCALSTORAGE_USER_UI_LANGUAGE_KEY);
    // const browserLang = navigator.language;
    // if (userLang) {
    //   return userLang;
    // } else {
    //   return (browserLang.match(/en|it/) ? browserLang.split('-')[0] : LOCALSTORAGE_DEFAULT_UI_LANGUAGE_KEY);
    // }
  }

  isValid(language: string) {
    return !!this.getSupportedLanguage().find(
      (l: Language) => l.id === language
    );
  }

  secureUpdateLanguage(language: string) {
    if (this.isValid(language)) {
      this.selectedLanguage = language as AvailableLanguages;
      this.loadLanguage();
    }
  }

  getLabelLanguage(lang: string): string {
    switch (lang) {
      case 'en':
        return 'English';
      case 'it':
        return 'Italiano';
    }
  }

  getSupportedLanguage(): Language[] {
    return [this.generateLanguage(AvailableLanguages.it)];
    // const loggedUser = this._loginResponse$();
    // if (loggedUser.system) {
    //   return [
    //     this.generateLanguage(AvailableLanguages.it),
    //     this.generateLanguage(AvailableLanguages.en)
    //   ];
    // } else {
    //   return [
    //     this.generateLanguage(AvailableLanguages.it),
    //   ];
    // }
  }

  generateLanguage(id: string): Language {
    return { id: id, label: of(this.getLabelLanguage(id)) };
  }

  loadLanguage() {
    this.translate.use(this.selectedLanguage);
    localStorage.setItem(
      LOCALSTORAGE_USER_UI_LANGUAGE_KEY,
      this.selectedLanguage
    );
  }

  initLanguages() {
    const defaultLang: string = SwitchLanguageService.getDefaultLanguage();
    this.translate.setDefaultLang(defaultLang);
    this.translate.use(defaultLang);
  }
}
